import envVariables from '../consts/envVariables';
import IAP_CUSTOM_FEATURE_NAMES from '../consts/iap/iapCustomFeatureNames';
import IAP_DEVICE_FEATURE_CODES from '../consts/iap/iapDeviceFeatureCodes';
import {IAP_FEATURES_CODES} from '../consts/iap/iapFeatureCodes';
import {uwmEntries, uwmFeedbackEntries} from '../consts/uwm/uwmEntries';
import assetsConfig from './assetsConfig';
import overrideThemeConfig from './overrideThemeConfig';

const defaultConfig = {
    app: {
        market: null,
        userGroup: null,
        consoleLog: {
            level: envVariables.CONSOLE_LOG_LEVEL,
        },
        cloudWatchLog: {
            level: envVariables.CLOUD_WATCH_LOG_LEVEL,
        },
        awsAmplifyConfig: {
            Auth: {
                Cognito: {
                    identityPoolId: envVariables.AWS_AUTH_IDENTITY_POOL_ID,
                    userPoolId: envVariables.AWS_AUTH_POOL_ID,
                    userPoolClientId: envVariables.AWS_AUTH_USER_POOL_WEB_CLIENT_ID,
                },
            },
        },
        deviceConfigHost: envVariables.DEVICE_CONFIG_HOST,
    },
    customFeatures: {
        [IAP_CUSTOM_FEATURE_NAMES.CA_CERTIFICATES]: null,
        [IAP_CUSTOM_FEATURE_NAMES.DEFAULT_DEVICE_TYPE]: IAP_DEVICE_FEATURE_CODES.ILUMA_I5,
    },
    deviceFeatures: {
        [IAP_FEATURES_CODES.ABOUT_DEVICE]: [],
        [IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC]: [],
        [IAP_FEATURES_CODES.ADVANCED_DIAGNOSTIC_PHASE_2]: [],
        [IAP_FEATURES_CODES.AI_ASSISTANT]: [],
        [IAP_FEATURES_CODES.APPEARANCE]: [],
        [IAP_FEATURES_CODES.AUTO_START]: [],
        [IAP_FEATURES_CODES.CONNECTIVITY]: [],
        [IAP_FEATURES_CODES.DEVICE_LOCK]: [],
        [IAP_FEATURES_CODES.EXPERIENCE_SCORE]: [],
        [IAP_FEATURES_CODES.FLEX_BATTERY]: [],
        [IAP_FEATURES_CODES.FLEX_PUFF]: [],
        [IAP_FEATURES_CODES.LED_INTENSITY]: [],
        [IAP_FEATURES_CODES.LOCATION]: [],
        [IAP_FEATURES_CODES.PAUSE_MODE]: [],
        [IAP_FEATURES_CODES.RANGE_MODE]: [],
        [IAP_FEATURES_CODES.REMEMBER_HEATING_PROFILE]: [],
        [IAP_FEATURES_CODES.SETUP]: [],
        [IAP_FEATURES_CODES.SIDEWALK]: [],
        [IAP_FEATURES_CODES.SMART_GESTURES]: [],
        [IAP_FEATURES_CODES.SOFTWARE_UPDATE]: [],
        [IAP_FEATURES_CODES.TIPS_AND_TUTORIALS]: [],
        [IAP_FEATURES_CODES.TUNABILITY]: [],
        [IAP_FEATURES_CODES.USAGE]: [],
        [IAP_FEATURES_CODES.VIBRATION]: [],
        [IAP_FEATURES_CODES.VIBRATION_INTENSITY]: [],
    },
    settings: {
        [IAP_FEATURES_CODES.DASHBOARD]: false,
        [IAP_FEATURES_CODES.SWITCH_MASTER_BADGE]: false,
    },
    assets: {
        ...assetsConfig,
    },
    overrideThemeConfig: {
        ...overrideThemeConfig,
    },
    marketLocalizations: [
        {
            market: 'PMI',
            languages: [
                {
                    name: 'PMI_CS',
                    isDefault: false,
                    language: 'CS',
                    path: `${envVariables.APP_TYPE}/PMI_CS.json`,
                },
                {
                    name: 'PMI_EN',
                    isDefault: true,
                    language: 'EN',
                    path: `${envVariables.APP_TYPE}/PMI_EN.json`,
                },
            ],
        },
        {
            market: 'CZ',
            languages: [
                {
                    name: 'CZ_CS',
                    isDefault: true,
                    language: 'CS',
                    path: `${envVariables.APP_TYPE}/CZ_CS.json`,
                },
            ],
        },
    ],
    uwmConfig: [
        {feature: uwmEntries.EXPERIENCE_COACH_MERCURY, uwm: 'mercury-experience-coach'},
        {feature: uwmEntries.EXPERIENCE_COACH_ORION, uwm: 'orion-experience-coach'},
        {feature: uwmEntries.DIAGNOSTIC_MERCURY, uwm: 'advanced-diagnostic'},
        {feature: uwmEntries.USAGE_MERCURY, uwm: 'usage-mercury'},
        {feature: uwmEntries.LOCATION, uwm: 'location'},
        {feature: uwmEntries.INSIGHTS_ORION, uwm: 'orion-insights-b'},
        {feature: uwmEntries.FEEDBACK_ORION, uwm: 'orion-feedback'},
        {feature: uwmFeedbackEntries.EXPERIENCE_COACH_MERCURY, uwm: 'feedback-mobile'},
        {feature: uwmFeedbackEntries.EXPERIENCE_COACH_ORION, uwm: 'feedback-mobile'},
        {feature: uwmFeedbackEntries.ONBOARDING, uwm: 'feedback-mobile'},
        {feature: uwmFeedbackEntries.ADVANCED_DIAGNOSTIC, uwm: 'feedback-mobile'},
        {feature: uwmFeedbackEntries.USAGE, uwm: 'feedback-mobile'},
    ],
};

export default defaultConfig;
